import logoMain from "../Images/logomain.png";

const logos = [
  {
    image: logoMain,
    alt: "logo",
    id: 0,
  },
];

export default logos;
